/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from '@codegrade/maybe';
/**
 * Parse the given value as a boolean.
 * If it is a boolean return it, if it is 'false' or 'true' convert
 * that to its correct boolean value, otherwise return `dflt`.
 *
 * @param value The value to try to parse.
 * @returns Maybe a boolean if parsing succeeded, a nothing otherwise.
 */
export function maybeParseBool(value) {
    if (typeof value === 'boolean') {
        return Maybe.of(value);
    }
    else if (typeof value === 'string') {
        const lowerVal = value.toLocaleLowerCase();
        if (lowerVal === 'false') {
            return Maybe.of(false);
        }
        if (lowerVal === 'true') {
            return Maybe.of(true);
        }
    }
    return Maybe.empty();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function parseBool(value, dflt = true) {
    return maybeParseBool(value).orDefault(dflt);
}
